import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enIView from 'view-design/dist/locale/en-US'
import zhIView from 'view-design/dist/locale/zh-CN'
import esIView from 'view-design/dist/locale/es-ES'

import en from './en'
import zh from './zh'
import es from './es'

// 设置语言
const locale = 'zh'

Vue.use(VueI18n)

Vue.config.lang = locale
Vue.locale('en', {...enIView, ...en})
Vue.locale('zh', {...zhIView, ...zh})
Vue.locale('es', {...esIView, ...es})



// WEBPACK FOOTER //
// ./src/i18n/index.js